import React from 'react';
import { ThemeProvider, createTheme, CssBaseline } from '@mui/material';
import { themeOptions } from './Theme/Theme';
import Accueil from './Components/Accueil/Accueil';
import GameLobby from './Components/Game/GameLobby/GameLobby';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import { AlertProvider } from './contexts/AlertContext';
import Alert from './Components/Shared/Alert';
import PlaylistSwitchedSnackbar from './Components/Shared/PlaylistSwitchedSnackbar';
import Credits from './Components/Credits/Credits';
import { GameProvider } from './contexts/GameContext';
import { LanguageProvider } from './contexts/LanguageContext';
import { VolumeProvider } from './contexts/VolumeContext';

export interface IApplicationProps {}

const Application: React.FunctionComponent<IApplicationProps> = (props) => {
    const darkTheme = createTheme({
        ...themeOptions
    });

    return (
        <LanguageProvider>
        <VolumeProvider>
        <ThemeProvider theme={darkTheme}>
            <AlertProvider>
                <GameProvider>
                    <CssBaseline />

                    <Router>
                        <Alert />
                        <PlaylistSwitchedSnackbar />
                        <Routes>
                            <Route path="/" element={<Accueil />}></Route>

                            <Route path="/game/:gameid" element={<GameLobby />}></Route>
                            <Route path="/credits" element={<Credits />}></Route>
                        </Routes>
                    </Router>
                </GameProvider>
            </AlertProvider>
        </ThemeProvider>
        </VolumeProvider>
        </LanguageProvider>
    );
};

export default Application;
